import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface TriStateToggleProps {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
  label: string;
  id?: string;
}

export const TriStateToggle = ({ value, onChange, label, id }: TriStateToggleProps) => {
  return (
    <div className="flex items-center justify-between py-2">
      <label htmlFor={id} className="cursor-pointer font-medium text-sm">
        {label}
      </label>
      <div className="flex gap-1 bg-muted rounded-lg p-0.5">
        <button
          type="button"
          onClick={() => onChange(true)}
          className={cn(
            "px-3 py-1.5 text-xs font-medium rounded-md transition-colors",
            value === true
              ? "bg-primary text-primary-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          Tak
        </button>
        <button
          type="button"
          onClick={() => onChange(false)}
          className={cn(
            "px-3 py-1.5 text-xs font-medium rounded-md transition-colors",
            value === false
              ? "bg-secondary text-secondary-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          Nie
        </button>
        <button
          type="button"
          onClick={() => onChange(null)}
          className={cn(
            "px-3 py-1.5 text-xs font-medium rounded-md transition-colors",
            value === null
              ? "bg-accent text-accent-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          Brak informacji
        </button>
      </div>
    </div>
  );
};
